import {
  add,
  areIntervalsOverlapping,
  endOfDay,
  isSameDay,
  isWithinInterval,
} from 'date-fns';
import { v4 as uuid } from 'uuid';

import { CreateEventTimetable } from '@event/types';

export const timetableFactory = (
  timeSlotStart: Date,
  timeSlotLength?: number,
  isFullDay = false,
) => {
  const targetTimeSlotLength = timeSlotLength
    ? add(timeSlotStart, { hours: timeSlotLength - 1 })
    : endOfDay(timeSlotStart);

  return {
    uuid: uuid(),
    timeSlotStart,
    timeSlotEnd: isSameDay(timeSlotStart, targetTimeSlotLength)
      ? targetTimeSlotLength
      : endOfDay(timeSlotStart),
    isTillMidnight: !timeSlotLength,
    isFullDay,
  };
};

export const isOverLappingHelper = (
  timetable: CreateEventTimetable,
  newTimetable: CreateEventTimetable,
) =>
  areIntervalsOverlapping(
    {
      start: new Date(timetable.timeSlotStart),
      end: new Date(timetable.timeSlotEnd),
    },
    {
      start: new Date(newTimetable.timeSlotStart),
      end: new Date(newTimetable.timeSlotEnd),
    },
  );

export const isWithinIntervalHelper = (
  timeSlotStart: Date,
  timetable: CreateEventTimetable,
) =>
  isWithinInterval(timeSlotStart, {
    start: timetable.timeSlotStart,
    end: timetable.timeSlotEnd,
  });
